import p9_img from "./shose_man/p9.jpg";
import p10_img from "./shose_man/p10.jpg";
import p11_img from "./shose_man/p11.jpg";
import p12_img from "./shose_man/p12.jpg";

let data_product1 = [
  {
    id: 9,
    name: "BOBS SQUAD CHAOS  ",
    category: "men",
    image: p9_img,
    new_price: 1559.0,
    old_price: 2099.0,
    descriptions: "Stride out in comfort and sleek style wearing BOBS from Skechers. This sporty vegan design features a engineered mesh upper and a Skechers Memory Foam™ cushioned comfort insole",
  },
  {
    id: 10,
    name: "GLIDE-STEP TRAIL",
    category: "men",
    image: p10_img,
    new_price: 1999.0,
    old_price: 2599.5,
    descriptions: "Sporty comfort and durable traction meet in Skechers GLIDE STEP TRAIL. This outdoor trail style lace-up features a waterproof leather upper with a Skechers Air-Cooled Memory Foam insole",
  },
  {
    id: 11,
    name: "GO RUN SPEED BEAST",
    category: "men",
    image: p11_img,
    new_price: 1289.0,
    old_price: 1659.0,
    descriptions: " Beat your own record in superior comfort and performance technology wearing Skechers GO RUN Speed Beast. This lace-up running design features a breathable monomesh upper with a removab",
  },
  {
    id: 12,
    name: "UNO - KEEP CLOSE",
    category: "men",
    image: p12_img,
    new_price: 2009.0,
    old_price: 2599.0,
    descriptions: "Step up your look with striking style in Skechers Street Uno - Keep Close. This lace-up fashion sneaker features a synthetic duraleather upper with a Skechers Air-Cooled Memory Foam i",
  },
];

export default data_product1;
